import { Box, Container, Stack, Button } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { useGetSearchHistory } from '@/api/endpoints/vendor/useGetSearchHistory';
import { ClockRewindIcon } from '@/assets/icons/ClockRewindIcon';
import { SearchLgIcon } from '@/assets/icons/SearchLgIcon';
import { PMPRoutes } from '@/config/routes';
import VendorSearchSection from '@/pages/public/sections/VendorSearchSection';

const VendorSearchPage: React.FC = () => {
  const history = useHistory();
  const { data: searchHistory, isLoading: isLoadingHistory } = useGetSearchHistory();

  const handleViewHistory = () => {
    history.push(PMPRoutes.vendorSearchHistory);
  };

  const handleViewMostRecentSearch = () => {
    if (searchHistory && searchHistory.length > 0) {
      const mostRecentSearch = searchHistory[0];
      history.push(`/property-manager/vendor-search-history/${mostRecentSearch.id}`, {
        search: mostRecentSearch,
      });
    }
  };

  const hasMostRecentSearch = searchHistory && searchHistory.length > 0;

  return (
    <Box sx={{ py: { xs: 2, md: 3 } }}>
      <Container maxWidth="lg">
        <Stack spacing={4}>
          {/* Header with Previous Searches buttons */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            {hasMostRecentSearch && (
              <Button
                variant="contained"
                onClick={handleViewMostRecentSearch}
                startIcon={<SearchLgIcon width={20} height={20} />}
                disabled={isLoadingHistory}
                sx={{
                  bgcolor: 'primary.main',
                  color: 'white',
                  '&:hover': {
                    bgcolor: 'primary.dark',
                  },
                }}
              >
                View Recent Search
              </Button>
            )}
            <Button
              variant="outlined"
              onClick={handleViewHistory}
              startIcon={<ClockRewindIcon width={20} height={20} />}
              sx={{
                borderColor: 'primary.main',
                color: 'primary.main',
                '&:hover': {
                  borderColor: 'primary.dark',
                  backgroundColor: 'primary.50',
                },
              }}
            >
              View All Searches
            </Button>
          </Box>

          {/* Vendor Search Section */}
          <Box
            sx={{
              mx: -3,
              my: -1,
              borderRadius: 2,
            }}
          >
            <VendorSearchSection />
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default VendorSearchPage;
